<template>
  <b-row>
    <b-col md="12">
      <table id="roomAvailability" class="table table-bordered">
        <tbody>
          <tr v-for="(hourKey,hourIndex) in roomAvailabilityModel" :key="hourIndex">
            <td style="text-align:center !important; vertical-align:middle !important;">
              {{ hourKey.key }}
            </td>
            <td>
              <div class="row" style="margin-left:0px !important; margin-right:0px !important;">
                <div :class="hourKey.value.length >= 4 ? 'col-md-3' : hourKey.value.length == 3 ? 'col-md-4' : hourKey.value.length == 2 ? 'col-md-6' : 'col-md-12'"
                     style="padding:0px !important;"
                     v-for="(item,index) in hourKey.value"
                     :key="index">
                  <template v-if="!item.isAvailable">
                    <button data-toggle="tooltip"
                            data-placement="bottom"
                            :title="$t(item.source)"
                            class="btn btn-block"
                            type="button"
                            style="padding:0px !important;"
                            disabled="disabled">
                      <b-badge variant="danger" style="width:100%; font-size:0.8rem;">
                        <font-awesome-icon icon="fa-regular fa-ban" style="color:darkred" />&nbsp;&nbsp;{{ item.startTime }} - {{ item.endTime }}
                      </b-badge>
                    </button>
                  </template>

                  <template v-else-if="item.startTime == startTime && item.endTime == endTime"
                            id="focusTime">

                    <button class="btn btn-block"
                            type="button"
                            style="padding:0px !important;"
                            @click="SetStartAndEndTime(item.startTime,item.endTime)">
                      <b-badge variant="primary" style="width:100%; font-size:0.8rem;">
                        <font-awesome-icon icon="fa-regular fa-clock" style="color:white" />&nbsp;&nbsp;{{ item.startTime }} - {{ item.endTime }}
                      </b-badge>
                    </button>

                  </template>
                  <template v-else>
                    <button class="btn btn-block"
                            type="button"
                            style="padding:0px !important;"
                            @click="SetStartAndEndTime(item.startTime,item.endTime)">
                      <b-badge variant="success" style="width:100%; font-size:0.8rem;">
                        <font-awesome-icon icon="fa-regular fa-check" style="color:#20861d" />&nbsp;&nbsp;{{ item.startTime }} - {{ item.endTime }}
                      </b-badge>
                    </button>
                  </template>
                </div>
              </div>
            </td>
          </tr>

        </tbody>
      </table>
      <span class="text-danger error-mes"
            v-if="!isTimeSelected"> {{ $t('NoChooseTime') }}</span>
    </b-col>
  </b-row>
</template>

<script>
  export default {
    name: 'AppointmentRoomAvailability',
    props: {
      roomAvailabilityModel: Array,
      startTime: String,
      endTime: String,
      isTimeSelected: Boolean
    },
    data() {
      return {
        serviceList: [],
      }
    },
    computed: {
      start: {
        get() {
          return this.startTime
        },
        set(newValue) {
          this.$emit('update:start-time', newValue);
          return newValue
        }
      },
      end: {
        get() {
          return this.endTime
        },
        set(newValue) {
          this.$emit('update:end-time', newValue);
          return newValue
        }
      },
    },
    methods: {
      SetStartAndEndTime(start, end) {
        this.start = start;
        this.end = end;
      }
    }
  }
</script>

<style>
  #roomAvailability.table td {
    padding: 0px !important;
  }
</style>
